import brandingDefaults from '../constants/default-data/branding';

const isDefaultSiteHeader = (siteHeader) =>
  siteHeader.url === brandingDefaults.siteHeader.url &&
  siteHeader.logo === brandingDefaults.siteHeader.logo &&
  siteHeader.ctaText === brandingDefaults.siteHeader.ctaText;

export default isDefaultSiteHeader;
